import React from 'react';
import { css } from '@emotion/core';
import ButtonWithLoadingEffect from 'Mui/ButtonWithLoadingEffect';
import SuccessButton from 'client/game_photoUpload/PhotoUpload/SuccessButton';
import { functional } from 'Mui/styles/color';

export const FEVER_BUTTON_TYPES = {
    TEXT: 1,
    IMAGE: 2
};

// 參考新客加入獎勵 - 未註冊頁面按鈕
/**
 * @method FeverButton - 圖片按鈕/自適應多行按鈕
 * @param {Object}   props
 * @param {Boolean}  props.loading        - 讀取中
 * @param {Boolean}  props.disabled       - 禁用
 * @param {Object}   props.componentStyle - 元件樣式
 * @param {String}   props.imageUrl       - 圖片網址
 * @param {Function} props.onClick        - 點擊事件
 * @param {Object}   props.text           - 按鈕文字
 * @param {String}   props.type           - 按鈕類型
 * @param {String}   props.customBtnStyle - 自制按鈕style
 * @param {Boolean}  props.isAutoWidth    - 按鈕寬度隨文字變寬
 * @returns {JSX.Element}
 */
export default function FeverButton({
    loading,
    disabled,
    componentStyle = {},
    imageUrl,
    onClick = () => {},
    text = '',
    type = FEVER_BUTTON_TYPES.TEXT,
    customBtnStyle,
    isAutoWidth = false
}) {
    return (
        <>
            {type === FEVER_BUTTON_TYPES.IMAGE ? (
                <ButtonWithLoadingEffect
                    disableAllRipple
                    onClick={onClick}
                    disabled={disabled}
                    isLoading={loading}
                    css={imageBtnStyle}
                >
                    {Boolean(imageUrl) ? (
                        <img src={imageUrl} alt="feverButton" css={imgStyle} />
                    ) : (
                        <div css={[placeHolderStyle(functional.color)]} />
                    )}
                </ButtonWithLoadingEffect>
            ) : (
                <SuccessButton
                    id="fv-button"
                    text={text}
                    style={[textBtnStyle(componentStyle?.bgColor, isAutoWidth), customBtnStyle]}
                    componentStyle={{
                        buttonLabelColor: `${componentStyle?.textColor}`
                    }}
                    onClick={onClick}
                    textStyle={textStyle}
                    disabled={disabled}
                    isLoading={loading}
                />
            )}
        </>
    );
}

const imgStyle = css`
    cursor: pointer;
    max-width: 100%;
    max-height: 56px;
`;

const placeHolderStyle = bgColor => css`
    border: 2px dashed;
    width: 240px;
    height: 56px;
    cursor: pointer;
    ${bgColor && `border-color:${bgColor};`}
`;

const imageBtnStyle = css`
    width: 240px;
    margin: auto;
    height: 56px;
    padding: 0;
    :hover,
    :active {
        background-color: transparent;
    }
`;

const textStyle = css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    box-sizing: border-box;
`;

const textBtnStyle = (bgColor, isAutoWidth) => css`
    width: ${isAutoWidth ? 'auto' : '100%'};
    min-width: 200px;
    max-width: unset;
    word-break: break-all;
    margin: auto;
    min-height: 56px;
    background: ${bgColor};
    &:hover {
        background-color: ${bgColor};
    }
`;
